import { Route } from 'react-router-dom'
import { routerType } from './PublicNavigation'
import React from 'react'

export default (pages: routerType[], base: string = '') => {
    return pages.map(({ path, title, element }: routerType) => (
        <Route key={title} path={base + path} element={element} />
    ))
}
